import { render, staticRenderFns } from "./StaticsCard.vue?vue&type=template&id=66115953&"
import script from "./StaticsCard.vue?vue&type=script&lang=js&"
export * from "./StaticsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports